(function () {
    'use strict';

    angular
        .module('recomControllers', [
        ]);
})();
